import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import {
  Container,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Typography,
  Divider,
  RadioGroup,
  Radio,
  Checkbox,
  TextField,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function getServerUrl(){
  const currentHost = document.location.hostname;
  if (currentHost === '127.0.0.1' || currentHost === 'localhost') {
    return 'http://localhost';
  } else {
    return 'https://wize-genrehab-service-504313099571.europe-west1.run.app';
  }
}

function App() {
  // State variables for each question

  // Question 1
  const [q1, setQ1] = useState({ option: "", other: "" });

  // Question 2
  const [q2, setQ2] = useState({ option: "", other: "" });

  // Question 3
  const [q3, setQ3] = useState({ option: "", other: "" });

  // Question 4
  const [q4, setQ4] = useState("");

  // Question 5
  const [q5, setQ5] = useState("");

  // Question 6
  const [q6, setQ6] = useState([]);

  // Question 7
  const [q7, setQ7] = useState({ option: "", diagnosis: "" });

  // Question 8
  const [q8, setQ8] = useState({ options: [], other: "" });

  // Question 9
  const [q9, setQ9] = useState([]);

  // Dialog open state
  const [open, setOpen] = useState(false);

  // Current step state (which question is currently displayed)
  const [currentStep, setCurrentStep] = useState(1);

  const [additionalInfo, setAdditionalInfo] = useState("");
  // Add new state
  const [showConfirm, setShowConfirm] = useState(false);

  const totalSteps = 10;
  let flagFirst = true;
  // Add loading state
  const [loading, setLoading] = useState(false);

  // Inside your component, add this state
  const [exerciseData, setExerciseData] = useState(null);

  const [errors, setErrors] = useState({
    q1: false,
    q2: false,
    q3: false,
    q4: false,
    q5: false,
    q6: false,
  });

  const resetForm = () => {
    setQ1({ option: "", other: "" });
    setQ2({ option: "", other: "" });
    setQ3({ option: "", other: "" });
    setQ4("");
    setQ5("");
    setQ6([]);
    setQ7({ option: "", diagnosis: "" });
    setQ8({ options: [], other: "" });
    setQ9([]);
    setExerciseData(null);
    setCurrentStep(1);
    setShowConfirm(false);
    setAdditionalInfo("");
    flagFirst = 1;
  };

  const handleSkip = () => {
    setCurrentStep(10);
  };

  const handleNext = () => {
    if (currentStep <= 6) {
      let isValid = true;

      switch (currentStep) {
        case 1:
          if (!q1.option) {
            setErrors((prev) => ({ ...prev, q1: true }));
            isValid = false;
          }
          break;
        case 2:
          if (!q2.option) {
            setErrors((prev) => ({ ...prev, q2: true }));
            isValid = false;
          }
          break;
        case 3:
          if (!q3.option) {
            setErrors((prev) => ({ ...prev, q3: true }));
            isValid = false;
          }
          break;
        case 4:
          if (!q4) {
            setErrors((prev) => ({ ...prev, q4: true }));
            isValid = false;
          }
          break;
        case 5:
          if (!q5) {
            setErrors((prev) => ({ ...prev, q5: true }));
            isValid = false;
          }
          break;
        case 6:
          if (q6.length === 0) {
            setErrors((prev) => ({ ...prev, q6: true }));
            isValid = false;
          }
          break;
        default:
      }

      if (isValid) {
        setErrors((prev) => ({ ...prev, [`q${currentStep}`]: false }));
        setCurrentStep(currentStep + 1);
      }
    } else if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Add state monitoring
  useEffect(() => {
    if (exerciseData) {
      console.log("exerciseData keys:", Object.keys(exerciseData));
      console.log("exercise:", exerciseData);
    }
  }, [exerciseData]);

  // Function to go to the previous question
  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  // Add confirm handler
  const handleConfirmWorkout = () => {
    resetForm();
    setOpen(false);
  };

  const handleApiResponse = (data) => {
    console.log("Raw API Response:", data);

    // Step 1: Remove backticks, 'json', and whitespace characters
    const cleanedData = data.replace(/```json\s*|\s*```/g, "");

    try {
      // Step 2: Parse the cleaned JSON string
      const parsedData = JSON.parse(cleanedData);
      console.log("Successfully parsed data:", parsedData);
      setExerciseData(parsedData);
      setShowConfirm(true);
    } catch (error) {
      console.error("JSON Parse Error:", error);
      console.log("Failed to parse string:", cleanedData);
    }
  };

  // Handle checkbox changes for multiple-choice questions with an options array
  const handleCheckboxChange = (e, state, setState) => {
    const value = e.target.value;
    const checked = e.target.checked;
    let newOptions = [...state.options];

    if (checked) {
      newOptions.push(value);
    } else {
      newOptions = newOptions.filter((option) => option !== value);
    }

    setState({ ...state, options: newOptions });
  };

  // Handle checkbox changes for questions without 'other' field
  const handleCheckboxChangeSimple = (e, state, setState) => {
    const value = e.target.value;
    const checked = e.target.checked;
    let newOptions = [...state];

    if (checked) {
      newOptions.push(value);
    } else {
      newOptions = newOptions.filter((option) => option !== value);
    }

    setState(newOptions);
  };

  const handleRemoveExercise = (exerciseKey) => {
    setExerciseData((prevData) => {
      const updatedData = { ...prevData };
      delete updatedData[exerciseKey]; // Remove the key from the object
      return updatedData;
    });
  };

  // Handle form submission
  const handleSubmit = async () => {
    setLoading(true);

    if (true) {
      try {
        flagFirst = 0;
        const data = {
          "What is the primary symptom the patient is experiencing?":
            q1.option === "Other" ? q1.other : q1.option,
          "Where is the primary symptom located?":
            q2.option === "Other" ? q2.other : q2.option,
          "What is the secondary symptom the patient is experiencing?":
            q3.option === "Other" ? q3.other : q3.option,
          "How did the symptoms start?": q4,
          "How long has the symptom been present?": q5,
          "Are there any contraindications or precautions to consider?": q6,
          "Has the doctor established a clear diagnosis for the patient?":
            q7.option,
          Diagnosis: q7.diagnosis,
          "How does the symptom affect the patient's daily function?": [
            ...q8.options.filter((opt) => opt !== "Other"),
            ...(q8.options.includes("Other") ? [q8.other] : []),
          ],
          "Does the patient have any relevant medical history?": q9,
          "Additional Information": additionalInfo,
        };
        const response = await axios.post(
          getServerUrl() + "/api/submit",
          data
        );
        handleApiResponse(response.data);
      } catch (error) {
        console.error(
          "Error details:",
          error.response ? error.response.data : error.message
        );
        const errorMsg =
          error.response && error.response.data && error.response.data.details
            ? error.response.data.details
            : "Error sending data!";
        alert(errorMsg);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const formattedExerciseData = {
          workoutName: exerciseData["Workout name"],
          duration: {
            workout: exerciseData["Workout Duration"],
            program: exerciseData["Program Duration"],
            frequency: exerciseData["Times per week"]
          },
          exercises: [
            exerciseData["Exercise 1"],
            exerciseData["Exercise 2"],
            exerciseData["Exercise 3"],
            exerciseData["Exercise 4"],
            exerciseData["Exercise 5"],
            exerciseData["Exercise 6"],
          ].filter(Boolean), // Remove any undefined exercises
          missingExercises: exerciseData["missing exercises"] || [],
        };

        const dataWithWorkout = {
          "What is the primary symptom the patient is experiencing?":
            q1.option === "Other" ? q1.other : q1.option,
          "Where is the primary symptom located?":
            q2.option === "Other" ? q2.other : q2.option,
          "What is the secondary symptom the patient is experiencing?":
            q3.option === "Other" ? q3.other : q3.option,
          "How did the symptoms start?": q4,
          "How long has the symptom been present?": q5,
          "Are there any contraindications or precautions to consider?": q6,
          "Has the doctor established a clear diagnosis for the patient?":
            q7.option,
          Diagnosis: q7.diagnosis,
          "How does the symptom affect the patient's daily function?": [
            ...q8.options.filter((opt) => opt !== "Other"),
            ...(q8.options.includes("Other") ? [q8.other] : []),
          ],
          "Does the patient have any relevant medical history?": q9,
          "Additional Information": additionalInfo,
          "Previous Workout": formattedExerciseData,
        };
        console.log("Data being sent:", dataWithWorkout);
        console.log("Exercise data:", formattedExerciseData);

        const response = await axios.post(
          getServerUrl() + "/api/submitWithHistory",
          dataWithWorkout
        );
        handleApiResponse(response.dataWithWorkout);
      } catch (error) {
        console.error(
          "Error details:",
          error.response ? error.response.data : error.message
        );
        const errorMsg =
          error.response && error.response.data && error.response.data.details
            ? error.response.data.details
            : "Error sending data!";
        alert(errorMsg);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleOpenDialog = () => {
    setOpen(true);
    setCurrentStep(1); // Reset to the first question whenever dialog is opened
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      {/* Button that opens the dialog */}
      <Box textAlign="center" mb={4}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#66BBB1", color: "white" }}
          onClick={handleOpenDialog}
        >
          Open Questionnaire
        </Button>
      </Box>

      {/* Dialog containing the form */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: "950px", // Set max-width to 1100px
            width: "100%", // Ensures it doesn't exceed screen width
          },
        }}
      >
        <DialogTitle>
          GenRehab Questionnaire for Clinicians
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            display: "flex",
            flexDirection: "row",
            paddingRight: "0px",
          }}
        >
          <Box component="form" noValidate autoComplete="off">
            {/* Question 1 */}
            {currentStep === 1 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    1. What is the primary symptom the patient is experiencing?
                    <br />
                    (Choose one that best matches the patient’s main complaint)
                  </FormLabel>
                  {errors.q1 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <RadioGroup
                    name="q1"
                    value={q1.option}
                    onChange={(e) =>
                      setQ1({
                        ...q1,
                        option: e.target.value,
                        other: e.target.value === "Other" ? q1.other : "",
                      })
                    }
                  >
                    {[
                      "Pain",
                      "Stiffness",
                      "Weakness",
                      "Instability",
                      "Limited Range of Motion (ROM)",
                      "Other",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                    {/* Other Option - only show when "Other" is selected */}
                    {q1.option === "Other" && (
                      <Box mt={2}>
                        <TextField
                          label="Please specify"
                          variant="outlined"
                          fullWidth
                          value={q1.other}
                          onChange={(e) =>
                            setQ1({ ...q1, other: e.target.value })
                          }
                        />
                      </Box>
                    )}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {/* Question 2 */}
            {currentStep === 2 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    2. Where is the primary symptom located?
                    <br />
                    (Select the affected body part)
                  </FormLabel>
                  {errors.q2 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <RadioGroup
                    name="q2"
                    value={q2.option}
                    onChange={(e) =>
                      setQ2({
                        ...q2,
                        option: e.target.value,
                        other: e.target.value === "Other" ? q2.other : "",
                      })
                    }
                  >
                    {[
                      "Shoulder",
                      "Elbow",
                      "Wrist",
                      "Lower Back",
                      "Hip",
                      "Knee",
                      "Ankle/Foot",
                      // "Other",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                  </RadioGroup>
                  {/* Other Option - only show when "Other" is selected */}
                  {/* {q2.option === "Other" && (
                    <Box mt={2}>
                      <TextField
                        label="Please specify"
                        variant="outlined"
                        fullWidth
                        value={q2.other}
                        onChange={(e) =>
                          setQ2({ ...q2, other: e.target.value })
                        }
                      />
                    </Box>
                  )} */}
                </FormControl>
              </Box>
            )}

            {/* Question 3 */}
            {currentStep === 3 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    3. What is the secondary symptom the patient is
                    experiencing?
                    <br />
                    (Choose one that complements the primary symptom)
                  </FormLabel>
                  {errors.q3 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <RadioGroup
                    name="q3"
                    value={q3.option}
                    onChange={(e) =>
                      setQ3({
                        ...q3,
                        option: e.target.value,
                        other: e.target.value === "Other" ? q3.other : "",
                      })
                    }
                  >
                    {[
                      "Pain",
                      "Stiffness",
                      "Weakness",
                      "Instability",
                      "Limited Range of Motion (ROM)",
                      "None / No secondary symptom",
                      // "Other",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                  </RadioGroup>

                  {/* {q3.option === "Other" && (
                    <Box mt={2}>
                      <TextField
                        label="Please specify"
                        variant="outlined"
                        fullWidth
                        value={q3.other}
                        onChange={(e) =>
                          setQ3({ ...q3, other: e.target.value })
                        }
                      />
                    </Box>
                  )} */}
                </FormControl>
              </Box>
            )}

            {/* Question 4 */}
            {currentStep === 4 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    4. How did the symptoms start?
                    <br />
                    (Select one)
                  </FormLabel>
                  {errors.q4 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <RadioGroup
                    name="q4"
                    value={q4}
                    onChange={(e) => setQ4(e.target.value)}
                  >
                    {[
                      "Gradually, over time (e.g., overuse or repetitive strain)",
                      "Suddenly, after an injury or trauma",
                      "Post-surgery or medical intervention",
                      "Unknown or unclear onset",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {/* Question 5 */}
            {currentStep === 5 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    5. How long has the symptom been present?
                    <br />
                    (Select one)
                  </FormLabel>
                  {errors.q5 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <RadioGroup
                    name="q5"
                    value={q5}
                    onChange={(e) => setQ5(e.target.value)}
                  >
                    {[
                      "Less than 2 weeks",
                      "2-6 weeks",
                      "6-12 weeks",
                      "More than 12 weeks",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {/* Question 6 */}
            {currentStep === 6 && (
              <Box mb={4}>
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    6. Are there any contraindications or precautions to
                    consider?
                    <br />
                    (Select all that apply)
                  </FormLabel>
                  {errors.q6 && (
                    <FormHelperText error>
                      This field is required
                    </FormHelperText>
                  )}
                  <FormGroup>
                    {[
                      "Acute pain or swelling",
                      "Recent surgery (within 6 weeks)",
                      "Cardiovascular limitations (e.g., high blood pressure, pacemaker)",
                      "Neurological issues (e.g., cognitive impairments, stroke)",
                      "None of the above",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        control={
                          <Checkbox
                            checked={q6.includes(option)}
                            onChange={(e) =>
                              handleCheckboxChangeSimple(e, q6, setQ6)
                            }
                            value={option}
                          />
                        }
                        label={option}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Box>
            )}

            {/* Question 7 */}
            {currentStep === 7 && (
              <Box mb={4}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    7. Has the doctor established a clear diagnosis for the
                    patient?
                    <br />
                    (Choose one)
                  </FormLabel>
                  <RadioGroup
                    name="q7"
                    value={q7.option}
                    onChange={(e) =>
                      setQ7({ option: e.target.value, diagnosis: "" })
                    }
                  >
                    {[
                      "Yes, a clear diagnosis has been made.",
                      "No, the diagnosis is unclear.",
                      "No formal diagnosis has been provided yet.",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={option}
                      />
                    ))}
                  </RadioGroup>
                  {q7.option === "Yes, a clear diagnosis has been made." && (
                    <Box mt={2}>
                      <TextField
                        label="Diagnosis"
                        variant="outlined"
                        fullWidth
                        value={q7.diagnosis}
                        onChange={(e) =>
                          setQ7({ ...q7, diagnosis: e.target.value })
                        }
                      />
                    </Box>
                  )}
                </FormControl>
              </Box>
            )}

            {/* Question 8 */}
            {currentStep === 8 && (
              <Box mb={4}>
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    8. How does the symptom affect the patient’s daily function?
                    <br />
                    (Select all that apply)
                  </FormLabel>
                  <FormGroup>
                    {[
                      "Difficulty walking or standing",
                      "Difficulty performing overhead or reaching activities",
                      "Pain or discomfort during specific movements (e.g., climbing stairs, lifting objects)",
                      "Limited ability to perform sports or recreational activities",
                      "Reduced ability to perform daily tasks (e.g., dressing, cooking, typing)",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        control={
                          <Checkbox
                            checked={q8.options.includes(option)}
                            onChange={(e) => handleCheckboxChange(e, q8, setQ8)}
                            value={option}
                          />
                        }
                        label={option}
                      />
                    ))}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={q8.options.includes("Other")}
                          onChange={(e) => handleCheckboxChange(e, q8, setQ8)}
                          value="Other"
                        />
                      }
                      label="Other"
                    />
                  </FormGroup>
                  {/* Other Option - only show when "Other" is checked */}
                  {q8.options.includes("Other") && (
                    <Box mt={2}>
                      <TextField
                        label="Please specify"
                        variant="outlined"
                        fullWidth
                        value={q8.other}
                        onChange={(e) =>
                          setQ8({ ...q8, other: e.target.value })
                        }
                      />
                    </Box>
                  )}
                </FormControl>
              </Box>
            )}

            {/* Question 9 */}
            {currentStep === 9 && (
              <Box mb={4}>
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    9. Does the patient have any relevant medical history?
                    <br />
                    (Select all that apply)
                  </FormLabel>
                  <FormGroup>
                    {[
                      "Previous injury or surgery in the affected area",
                      "Chronic conditions (e.g., arthritis, tendinopathy, or neurological disorders)",
                      "Use of a mobility aid (e.g., cane, crutches)",
                      "Medications that might impact rehabilitation (e.g., steroids, painkillers)",
                      "None of the above",
                    ].map((option) => (
                      <FormControlLabel
                        key={option}
                        control={
                          <Checkbox
                            checked={q9.includes(option)}
                            onChange={(e) =>
                              handleCheckboxChangeSimple(e, q9, setQ9)
                            }
                            value={option}
                          />
                        }
                        label={option}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Box>
            )}
            {currentStep === 10 && (
              <Box mb={4}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend" sx={{ fontSize: "20px" }}>
                    Additional Information
                    <br />
                    (Optional: Add any other relevant information about the
                    patient)
                  </FormLabel>
                  <TextField
                    multiline
                    rows={4}
                    value={additionalInfo}
                    onChange={(e) => setAdditionalInfo(e.target.value)}
                    variant="outlined"
                    fullWidth
                    sx={{ mt: 2 }}
                    placeholder="Enter any additional information here..."
                  />
                </FormControl>
              </Box>
            )}
            {currentStep === 10 && exerciseData && (
              <Box sx={{ textAlign: "left", mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  sx={{
                    minWidth: "140px",
                    backgroundColor: "rgb(23, 48, 82)",
                  }}
                >
                  Submit
                </Button>
              </Box>
            )}
          </Box>
          {exerciseData && (
            <Box
              sx={{
                padding: 2,
                marginLeft: "20px",
                backgroundColor: "#f5f5f5",
                borderRadius: 1,
                height: "max-content",
              }}
            >
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  borderBottom: "2px solid #000", // Add a bottom border
                  borderBottomColor: "rgba(74, 72, 72, 0.12)",
                  textAlign: "center",
                }}
              >
                {exerciseData["Workout name"]}
              </Typography>
              {/* Add workout details */}
              <Box
                sx={{
                  mb: 2,
                  textAlign: "center",
                  borderBottom: "2px solid #000",
                  borderBottomColor: "rgba(74, 72, 72, 0.12)",
                  color: "rgb(20 19 19 / 78%);",
                }}
              >
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Duration:
                  </Box>{" "}
                  {exerciseData["Workout Duration"]}
                </Typography>
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Program Length:
                  </Box>{" "}
                  {exerciseData["Program Duration"]}
                </Typography>
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Frequency:
                  </Box>{" "}
                  {exerciseData["Times per week"]}
                </Typography>
              </Box>
              {/* {exerciseData &&
                console.log(
                  Object.keys(exerciseData)
                    .filter((key) => key.startsWith("Exercise"))
                    .map((key) => (
                      <Box key={key} sx={{ mb: 2 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {key}:
                        </Typography>
                        <Typography>
                          Label: {exerciseData[key].label}
                        </Typography>
                        <Typography>
                          Explain: {exerciseData[key].explain}
                        </Typography>
                        <Box
                          component="img"
                          src="/excercise.jpeg"
                          alt="Exercise"
                          sx={{
                            width: "100%",
                            maxWidth: "40px",
                            borderRadius: 1,
                            mt: 1,
                          }}
                        />
                        <Divider sx={{ mt: 1 }} />
                      </Box>
                    ))
                )} */}

              {Object.keys(exerciseData)
                .filter((key) => key.startsWith("Exercise"))
                .map((key) => (
                  <Box
                    key={key}
                    sx={{
                      position: "relative", // so we can position the 'X' absolutely
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                      borderBottom: "2px solid #000",
                      borderBottomColor: "rgba(74, 72, 72, 0.12)",
                    }}
                  >
                    {/* Small "X" in the top-right corner */}
                    <IconButton
                      size="small"
                      sx={{ position: "absolute", top: 0, right: 50 }}
                      onClick={() => handleRemoveExercise(key)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>

                    {/* Left Column: Text */}
                    <Box sx={{ flex: 1, mr: 2 }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        <Box
                          component="span"
                          sx={{ fontWeight: "bold", color: "#66BBB1" }}
                        >
                          {key}:
                        </Box>{" "}
                      </Typography>
                      <Typography>
                        <Box component="span" sx={{ fontWeight: "bold" }}>
                          Label:
                        </Box>{" "}
                        {exerciseData[key].label}
                      </Typography>
                      <Typography>
                        <Box component="span" sx={{ fontWeight: "bold" }}>
                          Explain:
                        </Box>{" "}
                        {exerciseData[key].explain}
                      </Typography>
                    </Box>

                    {/* Right Column: Image */}
                    <Box
                      component="img"
                      src="/excercise.jpeg"
                      alt="Exercise"
                      sx={{
                        width: "100%",
                        maxWidth: "50px", // Adjust size of the image
                        borderRadius: 1,
                      }}
                    />
                    <Divider sx={{ mt: 1 }} />
                  </Box>
                ))}
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          {!loading && (
            <Box
              mt={2}
              display="flex"
              justifyContent="space-between"
              width="100%"
            >
              <Button
                variant="outlined"
                onClick={handleBack}
                disabled={currentStep === 1}
                sx={{ minWidth: "140px" }}
              >
                Back
              </Button>

              <Box display="flex" gap={2}>
                {showConfirm && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleConfirmWorkout}
                    sx={{
                      minWidth: "140px",
                      backgroundColor: "#66BBB1",
                    }}
                  >
                    Confirm Workout
                  </Button>
                )}
                {!exerciseData && currentStep === totalSteps && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{
                      minWidth: "140px",
                      backgroundColor: "rgb(23, 48, 82)",
                    }}
                  >
                    Submit
                  </Button>
                )}

                {currentStep < 7 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    sx={{ minWidth: "140px", backgroundColor: "#66BBB1" }}
                  >
                    Next
                  </Button>
                )}

                {currentStep >= 7 && currentStep < totalSteps - 1 && (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSkip}
                      sx={{ minWidth: "140px" }}
                    >
                      Skip
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      sx={{ minWidth: "140px", backgroundColor: "#66BBB1" }}
                    >
                      Next
                    </Button>
                  </>
                )}

                {currentStep === totalSteps - 1 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    sx={{ minWidth: "140px" }}
                  >
                    Next
                  </Button>
                )}
              </Box>
            </Box>
          )}

          {loading && (
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              width="100%"
              height={50}
            >
              <CircularProgress />
            </Box>
          )}
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default App;
